import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15.606.545l-7.21 7.211-2.767-2.768L2.4 8.217v1.697l3.229-3.228 2.767 2.768 7.21-7.211L18 4.635V2.939L15.606.545zm-6.56 10.121L2.4 13.486v1.304l6.646-2.822 4.302 1.825L18 9.142V7.446l-4.928 4.928-4.026-1.708zM1.2 0H0v18h18v-1.2H1.2V0z" />
  </svg>
);

export default SvgComponent;
